import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';

@Component({
  selector: 'app-viewof-reducton-confirmation-list',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule],
  templateUrl: './viewof-reducton-confirmation-list.component.html',
  styleUrl: './viewof-reducton-confirmation-list.component.scss'
})
export class ViewofReductonConfirmationListComponent {
  isDisabled: boolean = false;
  @Input() Message: string = '';
  @Input() Dataa: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  dtoptions: DataTables.Settings = {};
  constructor(
    private activeModal: NgbActiveModal,
    protected common: CommonService
  ) { 
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void { }

  close(result: boolean) {
    this.activeModal.close(result);
  }
}
